module.exports = __webpack_public_path__ + "static/media/google.ac7843db.jpg";